/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'
import auth_diagImg from 'assets/images/auth_diag.png'

export const _3 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>3 - Защищенные ресурсы</h2>
    <img className={styles.img} src={auth_diagImg} alt="auth_diag" />
  </section>
))
